import { useState } from "react";
import { X } from "lucide-react";

/**
 * Compact chip/tag input.
 * - Type and press Enter or comma to add.
 * - Backspace on empty input removes last chip.
 */
export default function TagInput({ value = [], onChange, placeholder = "Add and press Enter", testid }) {
  const [draft, setDraft] = useState("");

  const add = (raw) => {
    const items = String(raw || "").split(",").map((s) => s.trim()).filter(Boolean);
    if (items.length === 0) return;
    const lower = new Set(value.map((v) => String(v).toLowerCase()));
    const merged = [...value];
    for (const it of items) {
      if (!lower.has(it.toLowerCase())) {
        merged.push(it);
        lower.add(it.toLowerCase());
      }
    }
    onChange(merged);
    setDraft("");
  };

  const remove = (i) => {
    const next = value.filter((_, idx) => idx !== i);
    onChange(next);
  };

  return (
    <div className="flex flex-wrap items-center gap-1.5 min-h-[44px] px-2 py-1.5 rounded-xl border border-input bg-surface focus-within:ring-1 focus-within:ring-ring transition" data-testid={testid}>
      {value.map((tag, i) => (
        <span key={i} className="inline-flex items-center gap-1 bg-primary/10 text-primary text-xs font-medium px-2.5 py-1 rounded-full" data-testid={`${testid}-chip-${i}`}>
          {tag}
          <button type="button" onClick={() => remove(i)} className="hover:text-destructive" data-testid={`${testid}-remove-${i}`}><X size={11} /></button>
        </span>
      ))}
      <input
        className="flex-1 min-w-[120px] bg-transparent outline-none text-sm py-1"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === ",") {
            e.preventDefault();
            add(draft);
          } else if (e.key === "Backspace" && !draft && value.length > 0) {
            remove(value.length - 1);
          }
        }}
        onBlur={() => draft && add(draft)}
        placeholder={value.length === 0 ? placeholder : ""}
        data-testid={`${testid}-input`}
      />
    </div>
  );
}
